<template>
  <div id="app">
    <router-view/>
    <div v-show="loadingToast" class="main-loading">
      <van-loading color="white"></van-loading>
    </div>
  </div>
</template>
<script>
export default {
  created() {},
  methods: {},
  computed: {
    loadingToast() {
      return this.$store.state.loadingToast;
    },
  },
};
</script>

<style scoped lang="scss">
.main-loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;

  .van-loading {
    background: rgba(0, 0, 0, 0.5);
    width: halvePx(120);
    height: halvePx(120);
    border-radius: halvePx(10);
  }
}
</style>
